export default {
  name: 'company',
  type: 'object',
  properties: {
    companyName: {
      type: 'string',
      fieldRequired: true,
      minLength: 3,
      validationMessages: {
        minLength: 'Nazwa firmy zbyt krótka, minimum 3 znaki'
      }
    }
  }
};
